import { motion } from "framer-motion";

// Scroll-triggered fade-up reveal wrapper
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.25 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Small gold divider with a leaf glyph, used under section overlines
export const GoldDivider = ({ dark = false }) => (
  <div className="flex items-center justify-center gap-3 my-4">
    <span className="gold-rule" />
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden="true">
      <path
        d="M9 0C9 4 6 6 3 6c3 0 6 2 6 6 0-4 3-6 6-6-3 0-6-2-6-6Z"
        fill={dark ? "#C5A059" : "#1A3326"}
      />
    </svg>
    <span className="gold-rule" />
  </div>
);
